import { Pipe, PipeTransform } from "@angular/core";
import { isRichTextEmpty } from "./rich-text.utils";

@Pipe({
  name: "richTextIsEmpty",
})
export class RichTextIsEmptyPipe implements PipeTransform {
  transform(value: string): boolean {
    return isRichTextEmpty(value);
  }
}
